// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Tooltip, { TooltipPresentationProps } from "@steiner/MobiusOverrides/Tooltip";
import CutLengthIcon from "@steiner/XDL/Icons/CutLengthIcon";
import React, { FC } from "react";

interface OwnProps {}

export interface CutLengthBadgeStyles {
    container?: InjectableCss;
    iconStyles?: IconPresentationProps;
    tooltipStyles?: TooltipPresentationProps;
}

export const cutLengthBadgeStyles: CutLengthBadgeStyles = {};

type Props = OwnProps;

const styles = cutLengthBadgeStyles;

const CutLengthBadge: FC<Props> = () => {
    return (
        <StyledWrapper {...styles.container}>
            <Icon src={CutLengthIcon} {...styles.iconStyles} />
            <Tooltip
                text={`${siteMessage("Custom_Cut_Length_Enabled_Product")}`}
                placement="top"
                {...styles.tooltipStyles}
            />
        </StyledWrapper>
    );
};

export default CutLengthBadge;
